import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class WebLocaleCategory {
    @observable id!: number;

    @observable name!: string;

    @observable global!: boolean;

    constructor(page?: ModelProperties<WebLocaleCategory>) {
        if (page) {
            construct(this, page);
        }
    }
}